export default {"src":"/_next/static/media/gift.32839292.svg","height":21,"width":18};